export default __webpack_public_path__ + "static/mobile-ppq-modal-images-909374e1e1e19a7639642de440545cc4.png";